import { useEffect, useState } from "react";
import { Alert, Button, Form, Input, message, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { AppDispatch } from "shared/store/root.store";
import { AuthSliceMethods, getAuthState } from "features/auth/model/authSlice";
import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";
import { selectApiMode, setApiMode } from "shared/store/configSlice";

export function Login() {
  const [form] = useForm();
  const { t, i18n } = useTranslation();
  const { isLoggedIn } = useSelector(getAuthState);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState("");

  const [msg, msgCtx] = message.useMessage();

  const dispatch = useDispatch<AppDispatch>();
  const apiMode = useSelector(selectApiMode);

  useEffect(() => {
    if ((!isLoggedIn && localStorage.getItem("token")) || isLoggedIn) {
    }
  }, [isLoggedIn, dispatch]);

  // const pickBackendMessage = (res?: {
  //   ru?: string;
  //   ky?: string;
  //   kg?: string;
  //   eng?: string;
  // }) => {
  //   const lang = (i18n.language || "ru").toLowerCase();
  //   if (lang.startsWith("en")) return res?.eng;
  //   if (lang.startsWith("ky") || lang.startsWith("kg"))
  //     return res?.ky || res?.kg;
  //   return res?.ru;
  // };

  useEffect(() => {
    if (isLoggedIn || localStorage.getItem("token")) {
      navigate("/all-services", { replace: true });
    }
  }, [isLoggedIn, navigate]);

  const handleLogin = async () => {
    try {
      await form.validateFields();
    } catch {
      const errText = t("msg.fill_in_the_field", "Заполните поле(я)");
      setFormError(errText);
      message.error(errText);
      return;
    }

    setLoading(true);
    const key = "login";
    msg.open({
      key,
      type: "loading",
      content: t("auth.logging_in", "Входим..."),
      duration: 0,
    });

    try {
      await dispatch(
        AuthSliceMethods.login({
          username: form.getFieldValue("username"),
          password: form.getFieldValue("password"),
        }),
      ).unwrap();

      msg.open({
        key,
        type: "success",
        content: t("auth.welcome", "Добро пожаловать!"),
        duration: 2,
      });
      navigate("/all-services", { replace: true });
    } catch (e: any) {
      const res = e?.response?.data?.res;
      const backendMsg =
        ((): string | undefined => {
          if (!res) return undefined;
          const lang = (i18n.language || "ru").toLowerCase();
          if (lang.startsWith("en")) return res.eng;
          if (lang.startsWith("ky") || lang.startsWith("kg"))
            return res.ky || res.kg;
          return res.ru;
        })() || t("auth.invalid", "Неверный логин или пароль");

      setFormError(backendMsg ?? t("msg.error_logon", "Ошибка входа"));
      msg.open({ key, type: "error", content: backendMsg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      {msgCtx}

      <div className={styles.auroraSweep} aria-hidden="true" />

      <Select
        className={styles.selectApiMode}
        size="large"
        value={apiMode}
        onChange={(val) => {
          dispatch(setApiMode(val));
          message.success(
            val === "TEST" ? "API - agrosmart.gov.kg" : "API - agro.gov.kg",
          );
        }}
        options={[
          { value: "BASE", label: "Прод" },
          { value: "TEST", label: "Тестовый" },
        ]}
      />

      <Form
        form={form}
        className={styles.styledForm}
        layout="vertical"
        autoComplete="off"
      >
        <div className={styles.brandBadge}>
          <svg
            width="38"
            height="38"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 5.5C4 4.67157 4.67157 4 5.5 4H11V19H5.5C4.67157 19 4 18.3284 4 17.5V5.5Z"
              stroke="white"
              strokeWidth="1.6"
              strokeLinejoin="round"
            />
            <path
              d="M20 5.5C20 4.67157 19.3284 4 18.5 4H13V19H18.5C19.3284 19 20 18.3284 20 17.5V5.5Z"
              stroke="white"
              strokeWidth="1.6"
              strokeLinejoin="round"
            />
            <path
              d="M11 7.5H7.5M11 10.5H7.5M11 13.5H7.5"
              stroke="white"
              strokeWidth="1.4"
              strokeLinecap="round"
            />
            <path
              d="M13 7.5H16.5M13 10.5H16.5M13 13.5H16.5"
              stroke="white"
              strokeWidth="1.4"
              strokeLinecap="round"
            />
          </svg>
        </div>

        <span className={styles.appName}>База справочников</span>
        <h3 className={styles.titleLogin}>{t("auth.logon1")}</h3>

        <Form.Item
          label={t("auth.email")}
          name="username"
          rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
        >
          <Input className={styles.inputLogin} />
        </Form.Item>

        <Form.Item
          label={t("auth.password")}
          name="password"
          rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
        >
          <Input.Password className={styles.inputLoginPas} />
        </Form.Item>

        {formError && (
          <Alert
            message={formError}
            type="error"
            showIcon
            style={{ marginBottom: 10 }}
          />
        )}

        <Button
          className={styles.buttonLogin}
          type="primary"
          htmlType="submit"
          loading={loading}
          onClick={handleLogin}
        >
          {t("auth.logon2")}
        </Button>
      </Form>

      <div className={styles.footerBrand}>
        <img src="/logo-AgroSmart.jpg" alt="" />
        <span>ГУ "АгроСмарт"</span>
      </div>
    </div>
  );
}
